import {
  AnchorSimpleIcon,
  ArrowLineUpRightIcon,
  ArrowRightIcon,
  ArrowsHorizontalIcon,
  ArrowsLeftRightIcon,
  BatteryPlusIcon,
  BookBookmarkIcon,
  BookmarkIcon,
  BoundingBoxIcon,
  BowlFoodIcon,
  BugDroidIcon,
  HeadCircuitIcon,
  CloverIcon,
  CoinsIcon,
  CompassIcon,
  CompassToolIcon,
  CornersInIcon,
  CourtBasketballIcon,
  CrownSimpleIcon,
  ExcludeSquareIcon,
  FireIcon,
  FlagIcon,
  GraphIcon,
  HandCoinsIcon,
  LightningIcon,
  MagicWandIcon,
  PathIcon,
  PentagramIcon,
  QuestionIcon,
  RoadHorizonIcon,
  RulerIcon,
  ShapesIcon,
  ShieldChevronIcon,
  SnowflakeIcon,
  TextAaIcon,
  TrendUpIcon,
  type Icon,
} from '@phosphor-icons/react'

/**
 * Temporary mapping from authored badge `iconId` to a Phosphor icon. Bespoke
 * art will replace this; until then, keep the mapping small and explicit so
 * each badge has a stable glyph identity. Unknown ids fall back to `Question`.
 */
const BOGGLE_BADGE_ICONS: Record<string, Icon> = {
  abecedarian: BookmarkIcon,
  anadrome: ArrowsLeftRightIcon,
  battery: BatteryPlusIcon,
  cartographer: CompassToolIcon,
  clutch: AnchorSimpleIcon,
  cornered: CornersInIcon,
  doubleDouble: CourtBasketballIcon,
  explorer: CompassIcon,
  frenzy: FireIcon,
  flag: FlagIcon,
  generalist: GraphIcon,
  greedy: HandCoinsIcon,
  juggernaut: ShieldChevronIcon,
  lexicographer: BookBookmarkIcon,
  longStart: PathIcon,
  luckyCharm: CloverIcon,
  machine: HeadCircuitIcon,
  master: CrownSimpleIcon,
  palindrome: ArrowsHorizontalIcon,
  pangrammatist: ExcludeSquareIcon,
  pizazz: MagicWandIcon,
  prospector: CoinsIcon,
  quickdraw: LightningIcon,
  sesquipedalian: RulerIcon,
  sorcerer: PentagramIcon,
  spellingBee: BugDroidIcon,
  square: BoundingBoxIcon,
  steady: RoadHorizonIcon,
  straight: ArrowLineUpRightIcon,
  straightForward: ArrowRightIcon,
  tartarSauce: BowlFoodIcon,
  unique: SnowflakeIcon,
  versatile: ShapesIcon,
  verbose: TrendUpIcon,
}

export function getBoggleBadgeIcon(iconId: string): Icon {
  return BOGGLE_BADGE_ICONS[iconId] ?? QuestionIcon
}
